/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftUpIcon64Regular = forwardRef('ArrowDCornerLeftUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M5.672 25.44a1.5 1.5 0 0 0 2.122 2.12l14.938-14.938A2.54 2.54 0 0 1 23 12.39V43.5a9.5 9.5 0 0 0 9.5 9.5h24a1.5 1.5 0 1 0 0-3h-24a6.5 6.5 0 0 1-6.5-6.5V12.39c.093.07.183.147.268.232l14.938 14.939a1.5 1.5 0 1 0 2.121-2.122L28.39 10.501a5.5 5.5 0 0 0-7.778 0L5.672 25.439Z" })));
});
